<template>
    <div class="container-fluid p-3">
        <div class="d-flex justify-content-between align-items-start">
            <div class="d-flex flex-row gap-2">
                <a class="link-primary" @click.prevent="$router.back()" href="#">
                    <inline-svg class="back-arrow mb-2" style="margin-top: 11px" src="/assets/img/icons/arrow-left.svg"/>
                </a>
                <div>
                    <div class="title">{{ cardDeck.title }}</div>
                    <div v-if="cardDeck.corporateBrand" class="card-deck-author">
                        <inline-svg src="/assets/img/test-logo-deck-card.svg"></inline-svg>
                        <inline-svg src="/assets/img/test-logo-deck-card.svg"></inline-svg>
                        <span class="me-2">
                            Created on {{ cardDeck.created_at | moment('DD MMM YYYY')}}<br>
                            by <b>{{ cardDeck.corporateBrand ? cardDeck.corporateBrand.brand_name : '' }}</b>
                        </span>
                        <div class="d-flex gap-1">
                            <span class="deck-card-regular__category-label cards-counter" v-if="cardDeck.cards">
                                {{  cardDeck.cards.length }} {{ cardDeck.cards === 1 ? 'card' : 'cards'}}
                            </span>
                            <span class="deck-card-regular__category-label" v-if="cardDeck.category">{{ cardDeck.category ? cardDeck.category.label : '' }}</span>
                        </div>
                    </div>
                    <div v-else class="card-deck-author">
                        <user-avatar v-if="cardDeck.owner" :user="cardDeck.owner"></user-avatar>
                        <span class="me-2">
                            Created on {{ cardDeck.created_at | moment('DD MMM YYYY')}}<br>
                            by <b>{{ cardDeck.owner ? cardDeck.owner.name : '' }}</b>
                        </span>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center" style="gap: 24px">
                <div class="deck-card-community__favorite" :class="{ 'selected': cardDeck.is_favorite }">
                    {{cardDeck.favorites_count ? cardDeck.favorites_count : '' }}
                    <a href=""><inline-svg src="/assets/img/icons/heart-rounded.svg"></inline-svg></a>
                </div>
                <btn class="btn btn-primary" @click="">
                    <inline-svg src="/assets/img/icons/file-plus-01.svg" class="me-1"></inline-svg>
                    Add to my Card Decks
                </btn>
            </div>
        </div>
        <div class="divider --vertical-24"></div>
        <div class="deck-card-list mt-2">
            <card v-for="card in cardDeck.cards" :card="card"></card>
        </div>
    </div>
</template>

<script>

import UserAvatar from "@/components/UserAvatar.vue";
import Card from "@/components/Card.vue"

export default {
    name: 'CardDeckCardsList',
    components: {UserAvatar, Card},
    data() {
        return {
            loading: {
                data: false
            },
            cardDeck: {
                cards: null
            },
        };
    },
    mounted() {
      this.getData();
    },
    methods: {
        getData() {
            this.loading.data = true;
            this.$http.post("/deck/get-card-deck", {deck_id: this.$route.params.id})
                .then((res) => {
                    this.cardDeck = res.body.data;
                    this.loading.data = false;
                })
                .catch((error) => {
                    this.loading.data = false;
                });
        }
    }
};
</script>
